import classNames from 'classnames';
import React from 'react';
import type { ReactElement } from 'react';

interface Props {
  className?: string;
}

export default function DiagonalLine({ className }: Props): ReactElement {
  return (
    <div
      className={classNames(
        `absoulte relative bottom-[0px] left-[0px] z-10 h-full w-full transform rounded-sm !bg-diagonal `,
        className
      )}
    ></div>
  );
}
